/*global FB*/
import React from 'react';
import css from './style.scss'
export default class FacebookLogin extends React.Component {
  responseApi (authResponse) {
    FB.api('/me', { fields: "accounts,email,first_name,last_name,picture.type(large){url}" }, (me) => {
      me.accessToken = authResponse.accessToken;
      this.props.responseHandler(me);
    });
  }
  checkLoginState (response) {
    if (response.authResponse) {
      console.log("grantedScopes", response.authResponse.grantedScopes)
      if(response.authResponse.grantedScopes.split(",").length<process.env.REACT_APP_FB_SCOPES.split(",").length - 2){
        this.props.onPermissionError()
      }else{
        this.responseApi(response.authResponse);
      }
    } else {
      if (this.props.responseHandler) {
        this.props.responseHandler({ status: response.status });
      }
    }
  }

  clickHandler () {
    console.log("scopes", process.env.REACT_APP_FB_SCOPES)
    FB.login(this.checkLoginState.bind(this), { scope: process.env.REACT_APP_FB_SCOPES, return_scopes:true, auth_type:"rerequest" });
  };

  render() {
    const {
      xfbml, cookie, version, language, fields, responseHandler,
      children, buttonText, onPermissionError, authType, ...props
    } = this.props;

    return (
      <button {...props} className={css.facebook_button} onClick={this.clickHandler.bind(this)}>
        {children}
        <img src="/assets/connect_with_facebook.png"></img>
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/shared/facebook/index.js